import { render, staticRenderFns } from "./EditAllotment.vue?vue&type=template&id=5c443c1a"
import script from "./EditAllotment.vue?vue&type=script&lang=js"
export * from "./EditAllotment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports